<template>
  <div class="Judge_management">
    <div class="title pdlr20">
      <h2>
        <span class="back_btn" @click="$router.go(-1)">
          <i class="el-icon-arrow-left"></i>
        </span>评委管理
      </h2>
    </div>
    <div style="padding:20px">
      <div style=";display:flex;justify-content: space-between;">
      <el-button type="primary" @click="dialogVisible=true">邀请评委</el-button>
        <el-input placeholder="请输入内容" v-model="name" style="width:240px;">
          <i slot="suffix" class="el-input__icon el-icon-search" @click="getJudgesByCompetition"></i>
        </el-input>
      </div>

      <myTable class="mt20" :tableObj="tableObj" @btnClick="btnClick" @changePageNo="changePage"></myTable>
    </div>
    <!-- 邀请评委 -->
    <el-dialog title="邀请评委" :visible.sync="dialogVisible" width="750px" :destroy-on-close="true">
      <el-form :model="params" ref="form" label-width="120px">
        <el-form-item
          label="评委姓名:"
          prop="name"
          :rules="{ required: true, message: '请填写评委姓名', trigger: 'blur' }"
        >
          <el-input
            style="width: 564px"
            placeholder="请输入评委姓名"
            maxlength="20"
            show-word-limit
            v-model="params.name"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="手机号:"
          prop="mobile"
          :rules="{ required: true, message: '请填写评委手机号', trigger: 'blur' }"
        >
          <el-input
            style="width: 564px"
            placeholder="手机号"
            maxlength="11"
            show-word-limit
            v-model="params.mobile"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="单位:"
          prop="company"
        >
          <el-input
            style="width: 564px"
            placeholder="单位"
            maxlength="50"
            show-word-limit
            v-model="params.company"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="简介:"
          prop="synopsis"
        >
          <el-input
            style="width: 564px"
            placeholder="简介"
            type="textarea"
            :rows="4"
            maxlength="300"
            show-word-limit
            v-model="params.synopsis"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="createJudgeBySchool">邀 请</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import myTable from "@/components/my_table";
export default {
  components: {
    myTable
  },
  data() {
    return {
      row: null, //临时操作对象
      name:'',
      tableObj: {
        list: [], //列表数据
        btnsWidth: "100px",
        btns: [
          //按钮组
          {
            name: "移除",
            funcName: "remove"
          }
        ],
        table_detail: [
          {
            width: "100px",
            prop: "name",
            label: "评委姓名"
          },
          {
            prop: "company",
            label: "单位"
          },
          {
            prop: "mobile",
            label: "手机号"
          },
          {
            prop: "synopsis",
            label: "个人简介"
          }
        ],
        layerpageinfo: {
          pageNo: 0,
          total: 0,
          pageSize: 10
        }
      },
      dialogVisible: false,
      params: {
        name: "",
        mobile: "",
        company: "",
        synopsis: ""
      }
    };
  },
  created() {
     this.getJudgesByCompetition();
  },
  methods: {
    // 列表
    getJudgesByCompetition() {
      let params = Object.assign({}, this.tableObj.layerpageinfo, {
        competition: this.$route.query.competition,
        name:this.name || ''
      });
      return new Promise(resolve => {
        this.api.getJudgesByCompetition(params).then(res => {
          if (res.error.err_code !== 0) return;
          this.tableObj.list = res.obj.list || [];
          this.tableObj.layerpageinfo.total = res.obj.totalSize;
          resolve();
        });
      });
    },
    // 邀请评委
    createJudgeBySchool() {
      let params = { ...this.params, id: this.$route.query.competition };
      if (!/^1[3456789]\d{9}$/.test(params.mobile)) {
        this.$message.info("手机号码格式不正确");
        return;
      }
      return new Promise(resolve => {
        this.api.createJudgeBySchool(params).then(res => {
          if (res.error.err_code !== 0) return;
          this.$message.success("已发送邀请！");
          this.dialogVisible = false;
          this.params = {
            name: "",
            mobile: "",
            company: "",
            synopsis: ""
          };
          this.getJudgesByCompetition();
          resolve();
        });
      });
    },
    // 按钮组
    btnClick(btn) {
      this.row = btn.row;
      switch (btn.btnFuncName) {
        case "remove":
         this.removeJudgeBySchool(btn.row.id).then(res=>{
           this.$message.success('已移除该评委！');
           this.getJudgesByCompetition();
         });
          break;
      }
    },
  // 撤回
    removeJudgeBySchool(id) {
      return new Promise(resolve => {
        this.$confirm("是否撤回?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            let params = { id: id };
            this.api.removeJudgeBySchool(params).then(res => {
              if (res.error.err_code !== 0) return;
              resolve();
            });
          })
          .catch(() => {
            resolve();
          });
      });
    },
    // 改变页数
    changePage(obj) {
      this.tableObj.layerpageinfo.pageNo = obj.val;
      this.getJudgesByCompetition();
    }
  }
};
</script>

<style lang="scss" scoped>
.Judge_management {
  background: #fff;
  .title {
    padding:20px 30px;
    h2 {
      display: flex;
      align-items: center;
      .back_btn {
        display: inline-block;
        width: 38px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        border: 1px solid #dcdfe6;
        margin-right: 14px;
        cursor: pointer;
        vertical-align: top;
      }
    }
    border-bottom: 1px solid #EEEEEE;
  }
  .title::before {
    display: none;
  }
}
</style>